module.exports = __webpack_public_path__ + "img/login_biaoti7.9ef44397.png";